import { usePathname } from "@/lib/nav";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";

// 헤더 끝 조각에 붙는 기록 이름 — 어느 주소에서 걸었는지 같이 들고 있어 옮겨 간 화면에 옛 이름이 남지 않는다.
export interface CrumbRecord {
  pathname: string;
  name: string;
}

type SetCrumb = (next: CrumbRecord | null) => void;

const CrumbValueContext = createContext<CrumbRecord | null>(null);
const CrumbSetContext = createContext<SetCrumb>(() => undefined);

export const CrumbProvider = ({ children }: { children: ReactNode }) => {
  const [crumb, setCrumb] = useState<CrumbRecord | null>(null);

  return (
    <CrumbSetContext.Provider value={setCrumb}>
      <CrumbValueContext.Provider value={crumb}>{children}</CrumbValueContext.Provider>
    </CrumbSetContext.Provider>
  );
};

// 지금 주소에서 건 이름만 돌려준다 — 다른 화면으로 넘어가는 사이에 앞 화면 이름이 비치지 않게.
export const crumbNameFor = (crumb: CrumbRecord | null, pathname: string | null): string | null =>
  crumb && pathname && crumb.pathname === pathname && crumb.name.trim() !== "" ? crumb.name : null;

export const useCrumbName = (pathname: string | null): string | null => crumbNameFor(useContext(CrumbValueContext), pathname);

// 상세 화면이 그려 두면 헤더 브레드크럼 끝에 이 이름이 붙는다 — 화면에는 아무것도 그리지 않는다.
export const CrumbName = ({ name }: { name: string }) => {
  const pathname = usePathname();
  const setCrumb = useContext(CrumbSetContext);

  useEffect(() => {
    setCrumb({ pathname, name });
    return () => setCrumb(null);
  }, [pathname, name, setCrumb]);

  return null;
};
